import {Component, ChangeDetectionStrategy} from '@angular/core';
import {GlobalService} from "@app/_services/global.service";
import {ActivatedRoute, RouterLink} from "@angular/router";
import {FormsModule} from "@angular/forms";
import {EdiFileBaseService} from "@app/processing/services/edi-file-base.service";
import {EdiFileSummaryBaseComponent} from "@app/processing/edi-file-summary-base/edi-file-summary-base.component";
import {
    NgbDropdown,
    NgbDropdownAnchor,
    NgbDropdownItem,
    NgbDropdownMenu, NgbModal,
    NgbPagination
} from "@ng-bootstrap/ng-bootstrap";
import {AsyncPipe, NgClass} from "@angular/common";
import {SortableDirective} from "@app/_directives/sortable.directive";
import {EdiFile867Service} from "@app/processing/services/edi-file-867.service";
import {ToastService} from "@app/_services/toast.service";
import {ClipboardService} from "@app/_services/clipboard.service";
import {ModalConfirmComponent} from "@app/_components/modal-confirm/modal-confirm.component";
import {EdiFileSummaryFilterComponent} from "@app/processing/edi-file-summary-filter/edi-file-summary-filter.component";
import {EdiFileInvalidIdentifiersService} from "@app/processing/services/edi-file-invalid-identifiers.service";
import {TablePagerComponent} from "@app/_components/table-pager/table-pager.component";

@Component({
    selector: 'edi-867-file-summary',
    imports: [
        TablePagerComponent,
        FormsModule,
        NgbPagination,
        AsyncPipe,
        SortableDirective,
        NgClass,
        RouterLink,
        NgbDropdownAnchor,
        NgbDropdownMenu,
        NgbDropdown,
        NgbDropdownItem,
        ModalConfirmComponent,
        EdiFileSummaryFilterComponent
    ],
    providers: [
        {provide: EdiFileBaseService, useClass: EdiFile867Service}
    ],
    templateUrl: '../edi-file-summary-base/edi-file-summary-base.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: '../edi-file-summary-base/edi-file-summary-base.component.scss'
})
export class Edi867FileSummaryComponent extends EdiFileSummaryBaseComponent {
    constructor(
        globalService: GlobalService,
        route: ActivatedRoute,
        ediFileService: EdiFileBaseService,
        invalidIdentifierService: EdiFileInvalidIdentifiersService,
        toastService: ToastService,
        modalService: NgbModal,
        clipboardService: ClipboardService
    ) {
        super(globalService, route, ediFileService, invalidIdentifierService, toastService, modalService, clipboardService);
    }
}
